export default __webpack_public_path__ + "static/media/friends.7b316070.svg";